/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type BodyPart = typeof BodyPart[keyof typeof BodyPart];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BodyPart = {
  CERVICAL: 'CERVICAL',
  DORSAL: 'DORSAL',
  LUMBAR: 'LUMBAR',
  SHOULDER: 'SHOULDER',
  ARM: 'ARM',
  ELBOW: 'ELBOW',
  FOREARM: 'FOREARM',
  WRIST: 'WRIST',
  HAND: 'HAND',
  HIP: 'HIP',
  THIGH: 'THIGH',
  KNEE: 'KNEE',
  CALF: 'CALF',
  ANKLE: 'ANKLE',
  FOOT: 'FOOT',
  CORE: 'CORE',
  CHEST: 'CHEST',
  OFFICE: 'OFFICE',
  FINGER: 'FINGER',
  GLUTEUS: 'GLUTEUS',
} as const;
